import {Dispatch, FC, SetStateAction} from 'react'
import {ModalComponent} from '../../../Layout/Modal'
import {Header, TableDetailWrapper} from '../componente'

type ModalSize = 'xl' | 'md' | 'sm' | 'lg'

interface Props {
  show: boolean
  setShow: Dispatch<SetStateAction<boolean>>
  data?: any[]
  data1?: any[]
  file?: any
  message?: string
  textData?: string
  textData1?: string
  size?: ModalSize
}

const ModalErrorTable: FC<Props> = ({
  show,
  setShow,
  data = [],
  data1 = [],
  file,
  message = '',
  textData1 = '',
  textData = '',
  size = 'lg',
}) => {
  const handleClose = () => {
    setShow(!show)
  }
  return (
    <ModalComponent
      type='Alert'
      variant={'error'}
      show={show}
      centered={true}
      handleClose={handleClose}
      size={size}
    >
      <Header text={file?.name || ''} />
      <div className='mb-2'>
        {textData && (
          <p>
            <strong>{textData}</strong>
          </p>
        )}
        {data.length > 0 && <TableDetailWrapper response={data} />}
      </div>
      <div>
        {textData1 && (
          <p>
            <strong>{textData1}</strong>
          </p>
        )}
        {data1.length > 0 && <TableDetailWrapper response={data1} />}
      </div>
      {message && (
        <p>
          <strong>{message}</strong>
        </p>
      )}
    </ModalComponent>
  )
}

export {ModalErrorTable}
